<script>
	export let color = 'white';
	export let callback = null;
	export let href = false;
	export let reload = false;
	export let solid = false;
	export let margin = false;
	export let disabled = false;
</script>

<style>
	button, .button {
		display:inline-block;
		padding:0 0.6em 0 0.6em;
		border:0.15em solid var(--custom);
		background:transparent;
		color:var(--custom);
		font-family:var(--font);
		line-height:var(--line);
		font-weight:400;
		letter-spacing:var(--tracking);
		cursor:pointer;
		outline:none;
		font-size:1em;
		pointer-events:auto;
	}
	button div, .button div {
		height:2em;
	}
	.solid {
		background:var(--custom);
		color:var(--black);
	}
	.margin {
		margin:0.33em;
	}
	.disabled {
		opacity:0.5;
		pointer-events:none;
	}
</style>


{#if href}
	<a
		class="button inline-block text-ui"
		style="--custom:var(--{color})"
		class:solid
		class:margin
		class:disabled
		data-sveltekit-reload={reload ? '' : 'off'}
		href={href}
	>
		<div class="flex">
			<slot></slot>
		</div>
	</a>
{:else}
	<button
		type="button"
		style="--custom:var(--{color})"
		class="inline-block text-ui"
		class:solid
		class:margin
		class:disabled
		on:click={callback}
	>
		<div class="flex">
			<slot></slot>
		</div>
	</button>
{/if}